<template>
  <v-card>
    <v-row class="mt-5 ml-5 mr-5">
      <v-col cols="12" md="3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Username, firstname ,lastname..."
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="search_dep"
          :items="department_list"
          label="Department"
          filled
          @change="finddata"
          clearable
          @click:clear="
            $nextTick(() => {
              search_dep = '';
            })
          "
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="search_pos"
          :items="position_list"
          label="Position"
          filled
          @change="finddata"
          clearable
          @click:clear="
            $nextTick(() => {
              search_pos = '';
            })
          "
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="search_status"
          :items="status_list"
          label="Status"
          filled
          @change="finddata"
          clearable
          @click:clear="
            $nextTick(() => {
              search_status = '';
            })
          "
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      sort-by="calories"
      class="elevation-1 ma-5"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Employee</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="900px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#0A7EA5"
                rounded
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                @click="addEmp"
                :disabled="!authorize_add"
              >
                ADD EMPLOYEE
              </v-btn>
            </template>
            <v-card>
              <v-card-title
                class="justify-center text-center"
                style="color: #1976d2"
              >
                <v-container fluid>
                  <v-row style="margin-top: 30px">
                    <v-col cols="0" md="2"></v-col>
                    <v-col cols="12" md="8">
                      <span class="text-h4"
                        ><b>{{ formTitle }}</b></span
                      >
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        :items="emp_status"
                        v-model="editedItem.emp_status"
                        item-text="status_name"
                        item-value="id"
                        label="Status"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-divider color="black"></v-divider>
                </v-container>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-form ref="form">
                    <v-row>
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                          required
                          :rules="commonRules"
                          :items="prename_e_n"
                          v-model="editedItem.prename_e_n"
                          outlined
                          dense
                          ref="title_eng"
                        >
                          <template v-slot:label>
                            <span>Title <span style="color: red">*</span></span>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          :rules="commonRules"
                          required
                          v-model="editedItem.firstname_e_n"
                          outlined
                          dense
                          ref="firstname_eng"
                        >
                          <template v-slot:label>
                            <span
                              >Firstname (English)
                              <span style="color: red">*</span></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          :rules="commonRules"
                          required
                          v-model="editedItem.lastname_e_n"
                          outlined
                          dense
                          ref="lastname_eng"
                        >
                          <template v-slot:label>
                            <span
                              >Lastname (English)
                              <span style="color: red">*</span></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: -20px">
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                          :items="prename_t_h"
                          v-model="editedItem.prename_t_h"
                          label="Title"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="editedItem.firstname"
                          label="Firstname (Thai)"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="editedItem.lastname"
                          label="Lastname (Thai)"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row style="margin-top: -20px">
                      <!-- แก้ไข: บังคับกรอกทั้ง Email และ Phone Number ทั้งคู่ -->
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="editedItem.email"
                          outlined
                          :rules="emailRules"
                          required
                          dense
                          ref="email"
                        >
                          <template v-slot:label>
                            <span>Email <span style="color: red">*</span></span>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="editedItem.phone"
                          :rules="phoneRules"
                          required
                          outlined
                          dense
                          ref="phone"
                          maxlength="10"
                          @keypress="isNumber($event)"
                        >
                          <template v-slot:label>
                            <span
                              >Phone Number
                              <span style="color: red">*</span></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="editedItem.abbname_e_n"
                          label="English abbreviation"
                          hint="HINT:CK"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: -20px">
                      <v-col cols="12" sm="4" md="4">
                        <v-menu
                          v-model="menuStartDate"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <!-- <h3>Date</h3> -->
                            <v-text-field
                              v-model="computedStartDateFormatted"
                              append-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                              :rules="commonRules"
                              ref="StartDate"
                            >
                              <template v-slot:label>
                                <span>
                                  Start Date
                                  <span style="color: red">*</span>
                                </span>
                              </template>
                            </v-text-field>
                          </template>
                          <!-- :max="new Date(Date.now()).toISOString().substr(0, 10)" -->
                          <v-date-picker
                            v-model="editedItem.start_date"
                            @input="menuStartDate = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                          required
                          outlined
                          :rules="commonRules"
                          :items="company"
                          v-model="editedItem.company_i_d"
                          item-value="id"
                          item-text="name"
                          @change="changeCompany"
                          dense
                          ref="Company"
                        >
                          <template v-slot:label>
                            <span
                              >Company Name
                              <span style="color: red">*</span></span
                            >
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                          required
                          outlined
                          :rules="commonRules"
                          :items="department"
                          v-model="editedItem.department_i_d"
                          item-text="department_name"
                          item-value="id"
                          dense
                          ref="Department"
                          @change="changeDepartment"
                        >
                          <template v-slot:label>
                            <span
                              >Department
                              <span style="color: red">*</span></span
                            >
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row justify="center" style="margin-top: -20px">
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                          required
                          outlined
                          :rules="commonRules"
                          :items="position"
                          v-model="editedItem.position_i_d"
                          item-text="name"
                          item-value="id"
                          dense
                          ref="Position"
                        >
                          <template v-slot:label>
                            <span
                              >Position <span style="color: red">*</span></span
                            >
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                          required
                          outlined
                          :rules="commonRules"
                          :items="authorize"
                          v-model="editedItem.authorize_id"
                          item-value="id"
                          item-text="sgm_name"
                          dense
                          ref="Authorization"
                        >
                          <template v-slot:label>
                            <span
                              >Authorization
                              <span style="color: red">*</span></span
                            >
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="10" sm="3" md="3">
                        <v-text-field
                          v-model="editedItem.emp_rate"
                          label="Rate"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" sm="1" md="1">
                        <v-icon class="custom-icon mt-2" @click="desComCode()"
                          >mdi-help-circle</v-icon
                        >
                      </v-col>
                      <v-col cols="12" sm="3" md="3"> </v-col>
                    </v-row>
                    <v-row style="margin-top: -20px">
                      <v-col cols="12" sm="12" md="12">
                        <span class="text-h6"><b>Approver</b></span>
                        <span class="text-h6" style="color: red">*</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: -15px">
                      <v-col align="center" cols="12" sm="4" md="4">
                        <v-autocomplete
                          required
                          outlined
                          dense
                          :rules="commonRules"
                          v-model="editedItem.approver_level1"
                          :items="approver"
                          item-text="name"
                          item-value="id"
                          label="Select"
                          filled
                          clearable
                          @click:clear="
                            $nextTick(() => {
                              editedItem.approver_level1 = 0;
                            })
                          "
                          ref="Approver1"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="2" sm="1" md="1" v-if="slect_app_b2">
                        <v-icon
                          class="custom-icon mt-2"
                          @click="slect_approver(2)"
                          >mdi-plus</v-icon
                        >
                      </v-col>

                      <v-col
                        align="center"
                        cols="12"
                        sm="4"
                        md="4"
                        v-if="slect_app2"
                      >
                        <v-autocomplete
                          v-model="editedItem.approver_level2"
                          :items="approver"
                          item-text="name"
                          item-value="id"
                          label="Select"
                          filled
                          outlined
                          dense
                          clearable
                          @click:clear="
                            $nextTick(() => {
                              editedItem.approver_level2 = 0;
                            })
                          "
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="2" sm="1" md="1" v-if="slect_app_b3">
                        <v-icon
                          class="custom-icon mt-2"
                          @click="slect_approver(3)"
                          >mdi-plus</v-icon
                        >
                      </v-col>
                      <v-col
                        align="center"
                        cols="12"
                        sm="4"
                        md="4"
                        v-if="slect_app3"
                      >
                        <v-autocomplete
                          v-model="editedItem.approver_level3"
                          :items="approver"
                          item-text="name"
                          item-value="id"
                          label="Select"
                          filled
                          outlined
                          dense
                          clearable
                          @click:clear="
                            $nextTick(() => {
                              editedItem.approver_level3 = 0;
                            })
                          "
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: -20px">
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          :rules="commonRules"
                          v-model="editedItem.username"
                          outlined
                          dense
                          :disabled="!toggleDisable"
                          ref="username"
                        >
                          <template v-slot:label>
                            <span
                              >User Name <span style="color: red">*</span></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          :rules="commonRules"
                          v-model="editedItem.password"
                          outlined
                          dense
                          :disabled="!toggleDisable"
                          :append-icon="
                            isShowPassword ? 'visibility' : 'visibility_off'
                          "
                          @click:append="isShowPassword = !isShowPassword"
                          :type="isShowPassword ? 'text' : 'password'"
                          counter
                          ref="password"
                        >
                          <template v-slot:label>
                            <span
                              >Password <span style="color: red">*</span></span
                            >
                          </template>
                        </v-text-field>
                      </v-col>

                      <!-- <v-col cols="12" sm="4" md="4">
                      <v-file-input
                        label="image"
                        filled
                        prepend-icon="mdi-camera"
                        type="file"
                        @change="onFileSelected"
                      ></v-file-input>
                    </v-col> -->
                      <!-- <v-col cols="12" sm="4" md="4">
                      <input type="file" @change="onFileSelected" />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                      <v-card>
                        <v-img
                          lazy-src="https://upload.wikimedia.org/wikipedia/en/2/24/Crystal_personal.svg"
                          max-height="150"
                          class="mt-3"
                          aspect-ratio="1.7"
                          contain
                          :src="getImage()"
                        ></v-img>
                      </v-card>
                    </v-col> -->
                    </v-row>
                    <v-row style="margin-top: -15px" v-if="company_id == 1">
                      <v-col cols="12" sm="12" md="12">
                        <!-- <span><b>IP Authentication</b></span> -->
                        <span class="text-h6"><b>IP Authentication</b></span>
                        <span class="text-h6" style="color: red">*</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: -25px" v-if="company_id == 1">
                      <v-col cols="12" sm="2" md="2">
                        <v-radio-group v-model="ip_check">
                          <v-radio
                            label="NO"
                            value="no"
                            @click="checkbox_ip()"
                          ></v-radio>
                          <v-radio
                            label="IP Check"
                            value="yes"
                            @click="checkbox_ip()"
                          >
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="mt-11">
                        <v-text-field
                          v-model="editedItem.ip_authentication"
                          outlined
                          required
                          dense
                          :disabled="disipcheck"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- <v-row>
                    <v-col cols="12" sm="4" md="4"></v-col>
                    <v-col align="center" cols="12" md="4">
                      <v-row
                        :style="{ visibility: showsig1 ? 'visible' : 'hidden' }"
                      >
                        <VueSignaturePad
                          class="signature"
                          width="100%"
                          height="150px"
                          ref="firstsignaturePad"
                        />
                        <v-row
                          :style="{
                            visibility: showbuttonsavesig1
                              ? 'visible'
                              : 'hidden',
                          }"
                        >
                          <v-col align="center">
                            <v-btn depressed class="ml-5" @click="clearsig1()">
                              Clear
                            </v-btn>
                          </v-col>
                          <v-col>
                            <v-btn
                              class="mr-5 mb-5 primary"
                              depressed
                              @click="savesig1()"
                            >
                              Save
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-row>
                      <v-btn class="mr-2" @click="editsig1()">
                        {{ defaultwordbuttonsig1 }}
                        <v-icon right>mdi-border-color</v-icon>
                      </v-btn>
                    </v-col>

                    <v-col cols="12" sm="4" md="4"></v-col> -->
                    <v-row align="center" justify="center">
                      <v-btn
                        style="color: white"
                        rounded
                        class="mr-5"
                        color="green"
                        @click="save"
                        width="120"
                      >
                        Save
                      </v-btn>
                      <v-btn
                        style="color: white"
                        class="mr-5"
                        color="red"
                        @click="close"
                        width="120"
                        rounded
                      >
                        Cancel
                      </v-btn>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  Save
                </v-btn>
              </v-card-actions> -->
            </v-card>
          </v-dialog>
          &nbsp
          <!-- replace -->
          <v-dialog v-model="dialogApprover" max-width="900px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#0A7EA5"
                rounded
                dark
                outlined
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                @click="addEmp"
                :disabled="!authorize_add"
              >
                Approver input
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="justify-center text-center">
                <v-container fluid>
                  <v-row style="margin-top: 30px">
                    <v-col cols="12" md="12">
                      <span class="text-h4"><b>Approver input</b></span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <span class="text-h6">Search Employee</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: -20px">
                    <v-col cols="12" sm="8" md="8">
                      <v-autocomplete
                        v-model="repalceId"
                        :items="approver"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        prepend-inner-icon="mdi-magnify"
                        @input="showApproverData()"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <span class="text-h6">Employee Information</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: -10px">
                    <v-col cols="12" sm="6" md="6">
                      <span style="font-size: 16px">Name</span>
                      <v-text-field
                        v-model="name_show"
                        required
                        outlined
                        dense
                        disabled
                        background-color="#F5F5F5"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                      <span style="font-size: 16px">ID</span>
                      <v-text-field
                        v-model="id_show"
                        required
                        outlined
                        dense
                        disabled
                        background-color="#F5F5F5"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <span style="font-size: 16px">Department</span>
                      <v-text-field
                        v-model="department_show"
                        required
                        outlined
                        dense
                        disabled
                        background-color="#F5F5F5"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: -30px">
                    <v-col cols="12" sm="8" md="8">
                      <span style="font-size: 16px">Approver</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: -20px">
                    <v-col cols="12" sm="4" md="4">
                      <v-autocomplete
                        v-model="editedItem.approver_level1"
                        :items="approver"
                        item-text="name"
                        item-value="id"
                        label="Select"
                        filled
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <!-- <v-col cols="2"  sm="1" md="1"  v-if="slect_app_b2_r">
                        <v-icon 
                            class="custom-icon mt-2"
                            @click="slect_approver_r(2)"
                        >mdi-plus</v-icon>
                    </v-col> -->
                    <v-col cols="12" sm="4" md="4">
                      <v-autocomplete
                        v-model="editedItem.approver_level2"
                        :items="approver"
                        item-text="name"
                        item-value="id"
                        label="Select"
                        filled
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <!-- <v-col cols="2"  sm="1" md="1"  v-if="slect_app_b3_r">
                        <v-icon 
                            class="custom-icon mt-2"
                            @click="slect_approver_r(3)"
                        >mdi-plus</v-icon>
                    </v-col> -->
                    <v-col cols="12" sm="4" md="4">
                      <v-autocomplete
                        v-model="editedItem.approver_level3"
                        :items="approver"
                        item-text="name"
                        item-value="id"
                        label="Select"
                        filled
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>

                    <!-- <v-col cols="12" sm="4" md="4">
                      <v-file-input
                        label="image"
                        filled
                        prepend-icon="mdi-camera"
                        type="file"
                        @change="onFileSelected"
                      ></v-file-input>
                    </v-col> -->
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-btn
                      style="color: white"
                      rounded
                      class="mr-5"
                      color="green"
                      @click="saveReplace"
                      width="120"
                    >
                      Save
                    </v-btn>
                    <v-btn
                      style="color: white"
                      class="mr-5"
                      color="red"
                      @click="closeReplace"
                      width="120"
                      rounded
                    >
                      Cancel
                    </v-btn>
                  </v-row>
                </v-container>
              </v-card-text>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeReplace">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="saveReplace">
                  Save
                </v-btn>
              </v-card-actions> -->
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
          v-if="authorize_edit"
        >
          mdi-pencil
        </v-icon>
        <!-- <v-icon small @click="deleteItem(item)" v-if="authorize_del">
          mdi-delete
        </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="loadAccounts"> Reset </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogDecComCode" width="80%" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          <span style="font-size: 18px; font-weight: bold"> Rate/Hour </span>
        </v-card-title>
        <v-card-text>
          The 'Rate/Hour' is used to enter the hourly compensation rate this
          employee. This rate determines the amount to be paid for each hour of
          work which is linked with their check-in and check-out time.
        </v-card-text>
        <!-- <v-card-actions class="justify-center align-center text-center">
                    <v-btn color="primary" text @click="closeDialogDesComCode">close</v-btn>
                </v-card-actions> -->
      </v-card>
    </v-dialog>
    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
  </v-card>
</template>
<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { imageUrl } from "@/services/constants";
import unity from "@/unity/unity";
const moment = require("moment");

export default {
  data: () => ({
    isSuperAdmin: false,
    menuStartDate: false,
    department_show: "",
    name_show: "",
    id_show: "",
    // แก้ไข: บังคับกรอก email เสมอ และต้องเป็น format ที่ถูกต้อง
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v,
        ) || "E-mail must be valid",
    ],
    // แก้ไข: บังคับกรอก phone เสมอ
    phoneRules: [
      (v) => !!v || "Phone number is required",
      (v) => /^[0-9]*$/.test(v) || "Numbers only",
      (v) => (v && v.length <= 10) || "Max 10 digits",
    ],
    ip_check: "no",
    disipcheck: true,
    search_dep: "",
    search_pos: "",
    search_status: "",
    isShowPassword: false,
    commonRules: [(v1) => !!v1 || "This is required"],
    prename_t_h: ["นาย", "นาง", "นางสาว"],
    prename_e_n: ["Mr", "Miss", "Mrs."],
    emp_status: [
      { id: "A", status_name: "Active" },
      { id: "D", status_name: "Inactive" },
    ],
    user_role: [
      { id: "COMPANY_ADMIN", status_name: "COMPANY_ADMIN" },
      { id: "EMPLOYEE", status_name: "EMPLOYEE" },
    ],
    signature: "",
    defaultwordbuttonsig1: "Signature",
    showsig1: false,
    showbuttonsavesig1: false,
    options: {
      penColor: "#000000",
      backgroundColor: "rgb(255,255,255)",
    },
    status_list: ["Active", "Inactive"],
    dialog: false,
    dialogDelete: false,
    dialogEdit: false,
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    fullPage: true,
    search: "",
    headers: [
      //{ text: "Title", value: "prename_t_h" },
      {
        text: "Firstname(Thai)",
        align: "start",
        sortable: false,
        value: "firstname",
      },
      { text: "Lastname(Thai)", value: "lastname", sortable: false },
      // { text: "เบอร์", value: "phone" },
      // { text: "username", value: "username" },
      // { text: "role", value: "role" },
      // { text: "รหัสพนักงาน", value: "emp_i_d" },
      // { text: "prename_e_n", value: "prename_e_n" },
      { text: "Firstname(English)", value: "firstname_e_n", sortable: false },
      { text: "Lastname(English)", value: "lastname_e_n", sortable: false },
      //{ text: "abbname_e_n", value: "abbname_e_n" },
      { text: "Company", value: "company_name", sortable: false },
      { text: "Department", value: "department_name", sortable: false },
      { text: "Position", value: "position_name", sortable: false },
      //{ text: "Rate", value: "emp_rate" },
      { text: "Status", value: "emp_status_name", sortable: false },
      //{ text: "email", value: "email" },
      // { text: "password", value: "password" },
      //{ text: "image", value: "image" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    repalceId: 0,
    desserts: [],
    dataAll: [],
    replaceId: "",
    position: [],
    approver: [],
    department: [],
    department_list: [],
    position_list: [],
    position_list_all: [],
    company: [],
    editedIndex: -1,
    editedItemDel: {
      emp_status: "D",
      user_update: 0,
    },
    editedItem: {
      ip_check: "",
      prename_t_h: "",
      firstname: "",
      lastname: "",
      phone: "",
      username: "",
      emp_i_d: "",
      prename_e_n: "",
      firstname_e_n: "",
      lastname_e_n: "",
      abbname_e_n: "",
      start_date: null,
      company_i_d: 0,
      department_i_d: 0,
      position_i_d: 0,
      authorize_id: 0,
      emp_rate: 0.0,
      emp_status: "A",
      email: "",
      password: "",
      image: null,
      role: "",
      user_role: "",
      filename: "demo.png",
      approver_level1: 0,
      approver_level2: 0,
      approver_level3: 0,
      ip_authentication: "",
    },
    defaultItem: {
      prename_t_h: "",
      firstname: "",
      lastname: "",
      phone: "",
      username: "",
      role: "",
      user_role: "",
      emp_i_d: "",
      prename_e_n: "",
      firstname_e_n: "",
      lastname_e_n: "",
      abbname_e_n: "",
      start_date: null,
      company_i_d: 0,
      department_i_d: 0,
      position_i_d: 0,
      emp_rate: 0.0,
      emp_status: "A",
      email: "",
      password: "",
      image: "",
      approver_level1: 0,
      approver_level2: 0,
      approver_level3: 0,
      ip_authentication: "",
    },
    imageURL: null,
    toggleDisable: true,
    edit_item_id: 0,
    userId: 0,
    authorize: [],
    authorize_list: [],
    authorize_view: false,
    authorize_add: false,
    authorize_edit: false,
    authorize_del: false,
    authorize_id: 0,
    initial_data1: "",
    company_id: 0,
    dialogDecComCode: false,
    slect_app2: false,
    slect_app_b2: true,
    slect_app3: false,
    slect_app_b3: false,
    dialogApprover: false,
    oldmailedit: "",
    oldphoneedit: "",
  }),

  computed: {
    computedStartDateFormatted() {
      return unity.formatDate(this.editedItem.start_date);
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Employee" : "Edit Employee";
    },

    filteredData() {
      return this.desserts.filter((row) => {
        const name = row.firstname?.toLowerCase();
        const lastname = row.lastname?.toLowerCase();
        const username = row.username?.toLowerCase();
        const keyword = this.search.toLowerCase();

        return (
          name.includes(keyword) ||
          lastname.includes(keyword) ||
          username.includes(keyword)
        );
      });
    },
  },
  components: {
    SuccessDialog,
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogApprover(val) {
      val || this.closeReplace();
    },
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {
    this.initialize();
  },

  async mounted() {
    await api.checkVersion();
    // alert(localStorage.getItem(server.ROLE));
    this.showdefaultsignature();
    // ----------------- Check Authorize ---------------------------
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------
    this.company_id = parseInt(localStorage.getItem(server.COMPANYID));
    await this.checkSuperAdmin();
    await this.loadAccounts();
    let comp_id = localStorage.getItem(server.COMPANYID);
    await this.loadCompanyMaster(comp_id);
    await this.loadDepartmentMaster(comp_id);
    await this.loadPositionMaster(comp_id);

    await this.loadAuthorize(comp_id);

    // this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
  },

  methods: {
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async changeDepartment() {
      this.editedItem.position_i_d = 0;
      this.editedItem.authorize_id = 0;
      const positionsInDepartment = this.position_list_all.filter(
        (item) => item.department_id === this.editedItem.department_i_d,
      );
      if (positionsInDepartment) {
        this.position = positionsInDepartment;
      }
      const authorizeInDepartment = this.authorize_list.filter(
        (item) => item.department_id === this.editedItem.department_i_d,
      );
      if (authorizeInDepartment) {
        this.authorize = authorizeInDepartment;
      }
      console.log(this.position);
    },
    async desComCode() {
      this.dialogDecComCode = true;
    },
    async checkbox_ip() {
      // alert("testch")
      if (this.ip_check == "no") {
        this.disipcheck = true;
        this.editedItem.ip_authentication = "";
      } else {
        this.disipcheck = false;
      }
    },
    async changeCompany(selectObj) {
      this.position = [];
      this.editedItem.department_i_d = 0;
      this.editedItem.authorize_id = 0;
      await this.loadDepartmentMaster(selectObj);
      await this.loadAuthorize(selectObj);
    },
    finddata() {
      this.desserts = this.dataAll.filter((item) => {
        if (this.search_dep) {
          if (this.search_pos) {
            if (this.search_status) {
              if (
                item.department_name == this.search_dep &&
                item.position_name == this.search_pos &&
                item.emp_status_name == this.search_status
              ) {
                return item;
              }
            } else {
              if (
                item.department_name == this.search_dep &&
                item.position_name == this.search_pos
              ) {
                return item;
              }
            }
          } else {
            if (this.search_status) {
              if (
                item.department_name == this.search_dep &&
                item.emp_status_name == this.search_status
              ) {
                return item;
              }
            } else {
              if (item.department_name == this.search_dep) {
                return item;
              }
            }
          }
        } else {
          if (this.search_pos) {
            if (this.search_status) {
              if (
                item.position_name == this.search_pos &&
                item.emp_status_name == this.search_status
              ) {
                return item;
              }
            } else {
              if (item.position_name == this.search_pos) {
                return item;
              }
            }
          } else {
            if (this.search_status) {
              if (item.emp_status_name == this.search_status) {
                return item;
              }
            } else {
              return item;
            }
          }
        }
      });
    },
    addEmp() {
      this.toggleDisable = true;
    },
    getImage() {
      // console.log(`url_img : ${imageUrl}/${this.editedItem.image}`);
      return `${imageUrl}/${this.editedItem.image}`;
    },
    onFileSelected(event) {
      const reader = new FileReader();
      reader.onload = (event) => {
        // for preview image
        this.imageURL = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);

      // for upload image
      this.editedItem.image = event.target.files[0];

      // console.log("result image body : ", this.editedItem.image);
    },
    async loadAccounts() {
      var result;
      var resultList;

      // if (localStorage.getItem(server.ROLE) == "ADMIN") {
      //   result = await api.getAccounts();
      //   resultList = await api.getAccountslist();
      // } else {
      result = await api.getAccounts_by_ComID(
        localStorage.getItem(server.COMPANYID),
      );

      resultList = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID),
      );
      // }
      // const result = await api.getAccounts();
      // const result = await api.getAccounts_by_ComID(
      //   localStorage.getItem(server.COMPANYID)
      // );
      this.dataAll = result.data;
      this.desserts = this.dataAll;
      console.log(this.desserts);
      // const resultList = await api.getAccountslist();
      // const resultList = await api.getAccountslist_by_ComID(
      //   localStorage.getItem(server.COMPANYID)
      // );
      this.approver = resultList.data;

      //console.log(this.approver)
      // result.data.forEach((item) => {
      //   this.approver.push(item.firstname);
      // });

      // this.$showLoader();

      this.finddata();

      this.$hideLoader();
    },

    async loadCompanyMaster(id) {
      if (this.isSuperAdmin) {
        const result = await api.getAllCompany();
        this.company = result.data;
      } else {
        const result = await api.getCompanyMaster(id);
        this.company = result.data;
      }
    },

    async checkSuperAdmin() {
      try {
        const authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
        const res_sgm = await api.getSettingGroupMenu_ById(authorize_id);
        const sgmRow = res_sgm.data && res_sgm.data[0];
        const isNameMatch =
          !!sgmRow &&
          String(sgmRow.sgm_name || "")
            .trim()
            .toUpperCase() === "SYSTEM ADMIN";
        const isCompanyMatch = !!sgmRow && Number(sgmRow.company_id) === 1;
        this.isSuperAdmin = isNameMatch && isCompanyMatch;
      } catch (e) {
        console.error("checkSuperAdmin error:", e);
        this.isSuperAdmin = false;
      }
    },

    async loadDepartmentMaster(id) {
      const result = await api.getNewAllDepartment_By_CompanyID(id);
      // console.log("result.data : ", JSON.stringify(result.data));
      this.department = result.data;
      // console.log('test dapart')
      // console.log(this.department)
      result.data.forEach((item) => {
        this.department_list.push(item.department_name);
      });
    },
    async loadAuthorize(id) {
      const targetCompanyId = id || localStorage.getItem(server.COMPANYID);
      const res_get = await api.getSettingGroupMenu_By_CompanyID(
        targetCompanyId,
      );
      this.authorize_list = res_get.data;
    },

    async loadPositionMaster(id) {
      const result = await api.getPositionMaster(id);
      // console.log("result.data : ", JSON.stringify(result.data));

      result.data.forEach((item) => {
        this.position_list.push(item.name);
        this.position_list_all.push(item);
      });
    },

    async loadDetailAccount(id) {
      this.showsig1 = true;
      // console.log("loadDetailAccount:", id + "//");
      const result = await api.getAccountDetail(id);
      this.initial_data1 = result.data[0].signature;
      console.log("loadDetailAccount result: ");
      console.log(result);
      this.editedItem = Object.assign({}, result.data[0]);
      this.showdefaultsignature();
      this.showsig1 = true;
      this.showbuttonsavesig1 = true;

      if (Number(result.data[0].approver_level3 != 0)) {
        this.slect_app2 = true;
        this.slect_app3 = true;
        this.slect_app_b2 = false;
        // this.slect_app_b3 = false;
      } else if (Number(result.data[0].approver_level3 == 0)) {
        if (Number(result.data[0].approver_level2 != 0)) {
          this.slect_app2 = true;
          this.slect_app_b2 = false;
          this.slect_app_b3 = true;
        }
      }
    },

    initialize() {
      this.desserts = [
        {
          prename_t_h: "prename_t_h",
          firstname: "firstname",
          lastname: "lastname",
          emp_i_d: "emp_i_d",
          prename_e_n: "prename_e_n",
          firstname_e_n: "firstname_e_n",
          lastname_e_n: "lastname_e_n",
          abbname_e_n: "abbname_e_n",
          company_i_d: "company_i_d",
          department_i_d: "department_i_d",
          position_i_d: "position_i_d",
          emp_rate: "emp_rate",
          emp_status: "emp_status",
          role: "",
        },
      ];
    },

    editItem(item) {
      // console.log(item);
      this.toggleDisable = false;
      this.loadDetailAccount(item.id);
      this.edit_item_id = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.oldmailedit = this.editedItem.email;
      this.oldphoneedit = this.editedItem.phone; // ⭐ เพิ่มใหม่
      if (
        this.editedItem.ip_authentication != "" &&
        this.editedItem.ip_authentication != "0" &&
        this.editedItem.ip_authentication != null
      ) {
        this.ip_check = "yes";
        this.disipcheck = false;
        this.editedItem.ip_authentication = "";
      } else {
        this.ip_check = "no";
        this.disipcheck = true;
      }

      // alert(item.company_i_d);
      // alert(item.department_i_d);
      // alert(item.position_i_d);
      this.loadDepartmentMaster(item.company_i_d);
      this.loadAuthorize(item.company_i_d);
      this.changeDepartment();
      // this.loadPositionMaster(item.company_i_d);
      // const res_acc = await api.getAccountDetail(
      //     localStorage.getItem(server.item.id)
      //  );
      // this.initial_data1 = res_acc.data[0].signature;
      // this.edi

      this.dialog = true;
    },

    deleteItem(item) {
      // this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // this.dialogDelete = true;

      this.edit_item_id = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      // const account = this.desserts[this.editedIndex];
      // const result = await api.deleteUserAccount(account.id);
      // this.closeDelete();

      this.editedItemDel.user_update = this.userId;
      this.desserts.splice(this.editedIndex, 1);
      const res_del = await api.deleteUserAccount(
        this.edit_item_id,
        this.editedItemDel,
      );
      if (res_del.status == 200) {
        this.setupAlertDialog(
          true,
          "Success",
          "Delete data success",
          "text-h5 green--text text-center",
        );
        this.initialize();
      } else {
        this.setupAlertDialog(
          true,
          "Failed",
          "Delete data Failed",
          "text-h5 red--text text-center",
        );
      }

      this.closeDelete();
      await this.loadAccounts();
    },

    close() {
      this.$refs.form.reset();
      this.slect_app2 = false;
      this.slect_app_b2 = true;
      this.slect_app3 = false;
      this.slect_app_b3 = false;

      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.clearsig1();
      this.showsig1 = false;
      this.showbuttonsavesig1 = false;
      this.defaultwordbuttonsig1 = "signature";
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeReplace() {
      this.dialogApprover = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.repalceId = 0;
      });
    },
    async save() {
      if (this.editedItem.emp_status == "A") {
        if (this.editedItem.prename_e_n == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["title_eng"].focus();
          return;
        }

        if (this.editedItem.firstname_e_n == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["firstname_eng"].focus();
          return;
        }
        if (this.editedItem.lastname_e_n == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["lastname_eng"].focus();
          return;
        }

        // ---------- แก้ไข: บังคับกรอกทั้ง email และ phone ----------
        if (this.editedItem.email == "" || this.editedItem.email == null) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "กรุณากรอกอีเมล",
            "text-h5 red--text text-center",
          );
          this.$refs["email"].focus();
          return;
        }

        if (
          !/^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            this.editedItem.email,
          )
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "รูปแบบอีเมลไม่ถูกต้อง",
            "text-h5 red--text text-center",
          );
          this.$refs["email"].focus();
          return;
        }

        if (this.editedItem.phone == "" || this.editedItem.phone == null) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "กรุณากรอกเบอร์โทรศัพท์",
            "text-h5 red--text text-center",
          );
          this.$refs["phone"].focus();
          return;
        }

        // ---------- ⭐ เพิ่มใหม่: เช็คเบอร์โทรศัพท์ซ้ำกับ user อื่นในระบบ ----------
        var resCheckPhone = await api.getUserByPhoneComID(
          this.editedItem.phone,
          localStorage.getItem(server.COMPANYID),
        );
        console.log(resCheckPhone.data);
        if (this.editedIndex > -1) {
          // edit — เช็คเฉพาะกรณีมีการเปลี่ยนเบอร์โทรจากเดิม
          if (this.oldphoneedit != this.editedItem.phone) {
            if (resCheckPhone.data.length > 0) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Failed",
                "This phone number is already in use.",
                "text-h5 red--text text-center",
              );
              this.$refs["phone"].focus();
              return;
            }
          }
        } else {
          // add
          if (resCheckPhone.data.length > 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "This phone number is already in use.",
              "text-h5 red--text text-center",
            );
            this.$refs["phone"].focus();
            return;
          }
        }

        var resCheckMail = await api.getUserByEmailComID(
          this.editedItem.email,
          localStorage.getItem(server.COMPANYID),
        );
        console.log(resCheckMail.data);
        if (this.editedIndex > -1) {
          //edit
          if (this.oldmailedit != this.editedItem.email) {
            if (resCheckMail.data.length > 0) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Failed",
                "This email address is already in use.",
                "text-h5 red--text text-center",
              );
              this.$refs["email"].focus();
              return;
            }
          }
        } else {
          //add
          if (resCheckMail.data.length > 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              "This email address is already in use.",
              "text-h5 red--text text-center",
            );
            this.$refs["email"].focus();
            return;
          }
        }
        // ---------- จบส่วนแก้ไข ----------

        if (
          this.editedItem.start_date == "" ||
          this.editedItem.start_date == null
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["StartDate"].focus();
          return;
        }

        if (this.editedItem.company_i_d == 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["Company"].focus();
          return;
        }

        if (this.editedItem.department_i_d == 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["Department"].focus();
          return;
        }

        if (this.editedItem.position_i_d == 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["Position"].focus();
          return;
        }
        if (this.editedItem.authorize_id == 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["Authorization"].focus();
          return;
        }

        if (this.editedItem.username == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["username"].focus();
          return;
        }
        if (this.editedItem.password == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["password"].focus();
          return;
        }

        if (this.editedItem.approver_level1 == 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          this.$refs["Approver1"].focus();
          return;
        }
      } else {
        if (
          this.editedItem.start_date == null ||
          this.editedItem.start_date == "Invalid date"
        ) {
          this.editedItem.start_date = "";
        }
      }
      this.slect_app2 = false;
      this.slect_app_b2 = true;
      this.slect_app3 = false;
      this.slect_app_b3 = false;

      let formData = new FormData();
      formData.append("emp_i_d", this.editedItem.emp_i_d);
      formData.append("user_role", this.editedItem.user_role);
      formData.append("username", this.editedItem.username);
      formData.append("password", this.editedItem.password);
      formData.append("email", this.editedItem.email);
      formData.append("phone", this.editedItem.phone);
      formData.append("prename_t_h", this.editedItem.prename_t_h);
      formData.append("firstname", this.editedItem.firstname);
      formData.append("lastname", this.editedItem.lastname);
      formData.append("prename_e_n", this.editedItem.prename_e_n);
      formData.append("firstname_e_n", this.editedItem.firstname_e_n);
      formData.append("lastname_e_n", this.editedItem.lastname_e_n);
      formData.append("abbname_e_n", this.editedItem.abbname_e_n);
      formData.append("start_date", this.editedItem.start_date || "");
      formData.append("company_i_d", this.editedItem.company_i_d);
      formData.append("department_i_d", this.editedItem.department_i_d);
      formData.append("position_i_d", this.editedItem.position_i_d);
      formData.append("emp_rate", this.editedItem.emp_rate);
      formData.append("emp_status", this.editedItem.emp_status);
      formData.append("authorize_id", this.editedItem.authorize_id);
      formData.append("image", this.editedItem.image);
      formData.append(
        "approver_level1",
        this.editedItem.approver_level1 ? this.editedItem.approver_level1 : 0,
      );
      formData.append(
        "approver_level2",
        this.editedItem.approver_level2 ? this.editedItem.approver_level2 : 0,
      );
      formData.append(
        "approver_level3",
        this.editedItem.approver_level3 ? this.editedItem.approver_level3 : 0,
      );
      formData.append("ip_authentication", this.editedItem.ip_authentication);
      formData.append("signature", this.initial_data1);
      //alert(this.editedItem.approver_level1)
      //console.log("formData : ", formData);

      this.$showLoader();
      if (this.editedIndex > -1) {
        isShowPassword: false, formData.append("user_update", this.userId);

        Object.assign(this.desserts[this.editedIndex], this.editedItem);
        const id = this.desserts[this.editedIndex].id;
        // alert(id);
        // const payload = this.editedItem;
        const res_edit = await api.updateUserAccount(id, formData);
        this.$hideLoader();
        if (res_edit.data.message) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            res_edit.data.message,
            "text-h5 red--text text-center",
          );
          await this.loadAccounts();
        } else {
          if (Number(this.editedItem.company_i_d == 1)) {
            let data_edit_sme = {
              first_name: this.editedItem.firstname_e_n,
              last_name: this.editedItem.lastname_e_n,
              email: this.editedItem.email,
              status: "",
              department_id: Number(this.editedItem.department_i_d),
            };

            if (this.editedItem.emp_status == "A") {
              data_edit_sme.status = "Active";
            } else {
              data_edit_sme.status = "Inactive";
            }
            console.log("data_add_sme: ");
            console.log(data_edit_sme);

            await api.editUserSmeMate(id, data_edit_sme);
          }
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Edit data success",
            "text-h5 green--text text-center",
          );
          await this.loadAccounts();
        }
      } else {
        const res_cusername = await api.getCheckUsername(
          this.editedItem.username,
          Number(localStorage.getItem(server.COMPANYID)),
        );
        if (res_cusername.data[0].status_username > 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Username already in used, please choose another username.",
            "text-h5 red--text text-center",
          );
          return;
        }
        formData.append("user_create", this.userId);

        // Insert
        const res_add = await api.addUserAccount(formData);

        if (res_add.data.message) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            res_add.data.message,
            "text-h5 red--text text-center",
          );
        } else {
          if (Number(res_add.data.company_i_d == 1)) {
            let data_add_sme = {
              id: res_add.data.id,
              user_name: res_add.data.username,
              first_name: res_add.data.firstname_e_n,
              last_name: res_add.data.lastname_e_n,
              email: res_add.data.email,
              password: this.editedItem.password,
              role_id: 2,
              status: "",
              user_type: "User",
              department_id: Number(res_add.data.department_i_d),
              assign_permission: 0,
              expiration_date: "2099-01-01 00:00:00",
              user_create: res_add.data.user_create,
            };

            if (this.editedItem.emp_status == "A") {
              data_add_sme.status = "Active";
            } else {
              data_add_sme.status = "Inactive";
            }
            console.log("data_add_sme: ");
            console.log(data_add_sme);

            await api.addUserSmeMate(data_add_sme);
          }
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Add data success",
            "text-h5 green--text text-center",
          );
          await this.loadAccounts();
        }
      }

      this.close();
    },

    async saveReplace() {
      // console.log(data)
      if (this.repalceId == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "Please enter all the details.",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.editedItem.approver_level1 == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "Please enter all the details.",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.editedItem.approver_level2 == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "Please enter all the details.",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.editedItem.approver_level3 == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "Please enter all the details.",
          "text-h5 red--text text-center",
        );
        return;
      }
      let data1 = {};
      let data2 = {};
      let data3 = {};
      // alert(this.editedItem.approver_level1)
      data1.approver_level1 = this.editedItem.approver_level1;
      data2.approver_level2 = this.editedItem.approver_level2;
      data3.approver_level3 = this.editedItem.approver_level3;

      const res_rep1 = await api.replaceUserAccount1(this.repalceId, data1);
      const res_rep2 = await api.replaceUserAccount2(this.repalceId, data2);
      const res_rep3 = await api.replaceUserAccount3(this.repalceId, data3);
      if (res_rep1.data.message) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          res_rep1.data.message,
          "text-h5 red--text text-center",
        );
        await this.loadAccounts();
      } else {
        if (res_rep2.data.message) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            res_rep1.data.message,
            "text-h5 red--text text-center",
          );
          await this.loadAccounts();
        } else {
          if (res_rep3.data.message) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Failed",
              res_rep1.data.message,
              "text-h5 red--text text-center",
            );
            await this.loadAccounts();
          } else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Success",
              "replace data success",
              "text-h5 green--text text-center",
            );
            await this.loadAccounts();
          }
        }

        // this.$store.state.global_dialog = true;
        // this.setupAlertDialog(
        //   true,
        //   "Success",
        //   "replace data success",
        //   "text-h5 green--text text-center"
        // );
        // await this.loadAccounts();
      }

      this.closeReplace();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    editsig1() {
      this.showsig1 = true;
      this.showbuttonsavesig1 = true;
      //await Vue.nextTick();
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.fromDataURL(this.initial_data1);
      this.$refs.firstsignaturePad.openSignaturePad();
    },
    clearsig1() {
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.clearSignature();
      this.initial_data1 = "";
    },
    savesig1() {
      this.defaultwordbuttonsig1 = "Edit";
      this.showbuttonsavesig1 = false;

      const { isEmpty, data } = this.$refs.firstsignaturePad.saveSignature();
      this.initial_data1 = data;
      this.$refs.firstsignaturePad.resizeCanvas();
      this.$refs.firstsignaturePad.fromDataURL(this.initial_data1);
      //alert(this.signature)
      this.showbuttonsavesig1 = false;
      this.$refs.firstsignaturePad.lockSignaturePad();
    },
    showdefaultsignature() {
      this.$nextTick(() => {
        this.$refs.firstsignaturePad.resizeCanvas();
        this.$refs.firstsignaturePad.fromDataURL(this.initial_data1);

        // this.$refs.firstsignaturePad.lockSignaturePad();
        // this.$refs.firstsignaturePad.resizeCanvas();
        // this.$refs.firstsignaturePad.lockSignaturePad();
      });
    },
    async slect_approver(mode) {
      // alert(mode);
      if (mode == 2) {
        this.slect_app2 = true;
        this.slect_app_b2 = false;
        this.slect_app_b3 = true;
      } else if (mode == 3) {
        this.slect_app3 = true;
        this.slect_app_b2 = false;
        this.slect_app_b3 = false;
      }
    },
    async showApproverData() {
      // alert(this.repalceId)
      var data_show = {};
      data_show = this.desserts.find(
        (approver) => approver.id === this.repalceId,
      );
      console.log(data_show);
      this.name_show =
        data_show.prename_e_n +
        `. ` +
        data_show.firstname_e_n +
        ` ` +
        data_show.lastname_e_n;
      this.id_show = data_show.id;
      this.department_show = data_show.department_name;
    },
  },
};
</script>
<style scoped>
.custom-icon {
  color: #0a7ea5;
  /* สีเริ่มต้นของไอคอน */
  transition: color 0.3s;
  /* เพิ่มการเปลี่ยนแปลงสีให้มีความนุ่มนวล */
}

.row1 {
  padding-top: 20px;
}
</style>
